/* eslint-disable consistent-return */
import { notification } from 'antd'
import apiClient from '../index'

export const uploadManualPayroll = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    return await apiClient.post('employee/addMannulPayrollData', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || 'Failed to upload payroll data',
      })

      // Return detailed error information if available
      if (error.response.data.errors) {
        return {
          error: true,
          message: error.response.data.message,
          errors: error.response.data.errors,
        }
      }
    } else {
      notification.error({
        message: 'Error',
        description: 'An unexpected error occurred while uploading payroll data',
      })
    }

    throw error
  }
}

export const getEmpPayroll = async (params) => {
  const { skip, limit, locationId, empName, month, year } = params
  try {
    return await apiClient.get(`employee/emp-payroll`, {
      params: {
        skip,
        limit,
        locationId,
        empName,
        month,
        year,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getpayrollData = async (userId, month, year) => {
  try {
    return await apiClient.get(`employee/emp-payroll/${userId}`, {
      params: { month, year },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const updatePayroll = async (id, payrollData) => {
  try {
    return await apiClient.put(`employee/payroll/${id}`, payrollData) // Send the payrollData to the API
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    throw error // Ensure the error is thrown to be caught by the calling function
  }
}

export const getListOfEmployeeWithPayroll = async (params, options = {}) => {
  const { silent = false } = options
  const { skip, limit, month, year, employeeName, locationId, depId, userProcess } = params
  try {
    return await apiClient.get(`employee/getUsersWithPayroll`, {
      params: {
        skip,
        limit,
        month,
        year,
        employeeName,
        locationId,
        depId,
        userProcess,
      },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getListOfEmployeeWithPayrollData = async (params) => {
  const { month, year, employeeName, locationId, depId, userProcess } = params
  try {
    return await apiClient.get(`employee/getUsersWithPayrollData`, {
      params: {
        month,
        year,
        employeeName,
        locationId,
        depId,
        userProcess,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const sharePayrollByMonthYear = async (body) => {
  const { month, year } = body

  try {
    const monthString = String(month).padStart(2, '0')

    return await apiClient.post('employee/sharePayrollByMonthYear', {
      month: monthString,
      year,
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const sharePayrollToManager = async ({ month, year }) => {
  try {
    const monthString = String(month).padStart(2, '0')

    return await apiClient.post(`employee/share-payroll-to-manager`, {
      month: monthString,
      year,
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    throw error // 👈 important: rethrow so caller can catch it
  }
}

export const getPayrollBatchWorkspace = async (payrollMonth, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.get('payroll-batches/processing', {
      params: { payrollMonth },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getEmployeePayrollSelfService = async (params = {}, options = {}) => {
  const { silent = false } = options
  const { financialYear } = params

  try {
    return await apiClient.get('payroll-batches/self-service', {
      params: {
        financialYear,
      },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const getEmployeePayrollSnapshotReview = async (
  employeeId,
  { payrollMonth, userId } = {},
  options = {},
) => {
  const { silent = false } = options

  try {
    return await apiClient.get(`payroll-batches/processing/${employeeId}`, {
      params: {
        payrollMonth,
        userId,
      },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const generatePayrollBatch = async (payload = {}, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.post('payroll-batches/generate', payload, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const discardPayrollBatch = async (payload = {}, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.post('payroll-batches/discard', payload, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const approvePayrollBatch = async (payload = {}, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.post('payroll-batches/approve', payload, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const lockPayrollBatch = async (payload = {}, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.post('payroll-batches/lock', payload, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const regeneratePayrollBatch = async (payload = {}, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.post('payroll-batches/regenerate', payload, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const generatePayrollPayslips = async (payload = {}, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.post('payroll-batches/payslips/generate', payload, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const getPayrollPayslipView = async (payslipId, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.get(`payroll-batches/payslips/${payslipId}/view`, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}

export const getPayrollPayslipPdf = async (payslipId, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.get(`payroll-batches/payslips/${payslipId}/pdf`, {
      responseType: 'blob',
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }

    throw error
  }
}
